export enum Language {
  EN = 'en',
  UA = 'uk',
}

export enum ThemeVariants {
  LIGHT = 'light',
  DARK = 'dark',
  SYSTEM = 'system',
}

export enum MainThemeVariants {
  DEFAULT = 'default',
  RED = 'red',
  ROSE = 'rose',
  ORANGE = 'orange',
  GREEN = 'green',
  BLUE = 'blue',
  YELLOW = 'yellow',
  VIOLET = 'violet',
}

export enum RoutesPath {
  HOME = '/',
  FUEL_TRACKING = '/fuel',
  FUEL_HISTORY = '/fuel/history',
  SERVICE_MAINTENANCE = '/service',
  SERVICE_MAINTENANCE_HISTORY = '/service/history',
  SERVICE_CONTACTS = '/contacts',
  SERVICE_CONTACTS_HISTORY = '/contacts/history',
  ANALYTICS = '/analytics',
  SETTING = '/setting',
  CALENDAR = '/calendar',
  MY_CARS = '/my-cars',
  LOGIN = '/login',
  SIGNUP = '/signup',
  FILL_AUTO_INFO = '/fill-auto-info',
}

export enum LocalStorageKeys {
  LOCALE = 'locale',
  THEME = 'theme',
  COLOR_THEME = 'themeColor',
  AUTH_TOKEN = 'authToken',
  CURRENCY = 'currencies',
  DISTANCE_METRICS = 'distancemetrics',
  ACTIVE_CAR = 'activeCar',
  PREFER_LIST = 'preferList',
  STARRED_HIDE = 'starredHide',
  CONTACTS_HIDE = 'contactsHide',
  PERIOD_HOME_CHART = 'periodHomeChart',
}

export enum TypeTittle {
  LARGE = 'large',
  DEFAULT = 'default',
  SMALL = 'small',
}

export enum FirebaseFields {
  HISTORY_OF_FUEL_TRACK = 'historyOfFuelTrack',
  HISTORY_OF_MAINTENANCE = 'historyOfMaintenance',
  HISTORY_OF_SERVICE_CONTACTS = 'serviceContacts',
  LIST_OF_CARS = 'listOfCars',
}

export enum FirebaseCollections {
  CARS = 'cars',
}

export enum StorePersistKeys {
  FUEL_HISTORY = 'fuelHistory',
  MAINTENANCE_HISTORY = 'maintenanceHistory',
  SERVICE_CONTACTS = 'serviceContacts',
  MODELS_FOR_MAKE = 'modelsForMake',
  USER_CARS = 'usersCars',
  CURRENCY = 'currency',
}

export enum Currency {
  USD = 'usd',
  UAH = 'uah',
  PLN = 'pln',
  EUR = 'eur',
}

export enum DistanceMetrics {
  KM = 'km',
  MILES = 'miles',
}

export enum InputType {
  TEXT = 'text',
  NUMBER = 'number',
  SELECT = 'select',
  TEXTAREA = 'textarea',
}

export enum AnalyticsEvent {
  SIDEBAR_CLICK = 'sidebar_click',
  ADDING_NEW_CAR = 'adding_new_car',
  ADD_CONTACT = 'adding_new_contact',
  ADD_FUEL_ITEM = 'adding_new_fuel',
  ADD_NEW_MAINTENANCE = 'adding_new_maintenance',
  LOGIN = 'user_login',
  LOGOUT = 'user_logout',
  SIGNUP = 'user_signup',
}
